import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    states: [],
    voteData: [],
  },
  getters: {
    states(state) {
      return state.states;
    },
    voteData(state) {
      return state.voteData;
    }
  },
  mutations: {
    setStates(state, payload) {
      state.states = payload.states;
    },
    setVoteData(state, payload) {
      state.voteData = payload.voteData;
    }
  },
  actions: {
  },
  modules: {
  }
})
